import React, { useEffect, useState } from 'react';
import { Modal, Input, Typography, message, Tag } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const { TextArea } = Input;

function HallazgosCerrarModal({ target, onClose, onSuccess }) {
  const [razon, setRazon] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (target) setRazon('');
  }, [target]);

  const handleCerrar = async () => {
    const trimmed = razon.trim();
    if (!trimmed) {
      message.warning('La razón de cierre es obligatoria');
      return;
    }
    setLoading(true);
    try {
      await axios.post(
        `${API_PATH}/actividades-hallazgo/${target.id}/cerrar`,
        { razon_cierre: trimmed },
        { headers: { Authorization: getAccessTokenApi() } }
      );
      message.success('Hallazgo cerrado correctamente');
      onSuccess?.();
    } catch (err) {
      message.error(err?.response?.data?.message || 'Error al cerrar el hallazgo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={!!target}
      onCancel={onClose}
      onOk={handleCerrar}
      okText="Cerrar hallazgo"
      cancelText="Cancelar"
      okButtonProps={{
        icon: <CheckOutlined />,
        loading,
        disabled: !razon.trim(),
      }}
      title={
        <div className="flex items-center gap-2">
          <CheckOutlined className="text-emerald-600" />
          <span>Cerrar hallazgo</span>
        </div>
      }
      width={560}
      destroyOnHidden
    >
      {target && (
        <div className="space-y-4">
          <div className="rounded-xl bg-slate-50 p-4">
            <div className="mb-2 flex items-center gap-2">
              <Tag color={target.tipo === 'INCIDENCIA' ? 'red' : 'blue'}>{target.tipo}</Tag>
              {target.severidad && target.tipo === 'INCIDENCIA' && (
                <Tag color="orange">{target.severidad}</Tag>
              )}
            </div>
            <Typography.Text className="text-sm text-slate-700">
              {target.descripcion || '(sin descripción)'}
            </Typography.Text>
            {target.Cliente?.name && (
              <div className="mt-2 text-xs text-slate-500">
                <strong>Cliente:</strong> {target.Cliente.name}
                {target.Ascensor?.nombre && (
                  <>
                    {' · '}
                    <strong>Ascensor:</strong> {target.Ascensor.nombre}
                  </>
                )}
              </div>
            )}
          </div>
          <div>
            <label className="mb-2 block text-[11px] font-bold uppercase tracking-wider text-slate-500">
              Razón de cierre <span className="text-rose-500">*</span>
            </label>
            <TextArea
              value={razon}
              onChange={(e) => setRazon(e.target.value)}
              placeholder="Describe cómo se resolvió o por qué ya no aplica..."
              rows={4}
              className="!rounded-xl"
              maxLength={500}
              showCount
            />
          </div>
        </div>
      )}
    </Modal>
  );
}

export default HallazgosCerrarModal;
